export enum CourseAttendeeStatus {
  Valid = 1,
  Expired = 2,
  InProgress = 3,
}
